<template>
  <div class="card">
      <h1>Subscription</h1>
      <div v-if="session">
          <p class="first-para grey-letters">Name: {{ user.username }}</p>
          <p v-if="user.is_subscribed" class="grey-letters">Has subscribed: Yes</p>
          <p v-else class="grey-letters">Has subscribed: No</p>
          <p class="grey-letters">price: 5.99 $</p>
          <p class="grey-letters">billing period: monthly</p>
          <p class="grey-letters">last payment date: 2025-02-12</p>
          <p class="grey-letters">next billing date: 2025-03-12</p>
      </div>
      
      <div class="button-container" v-if="user.is_subscribed">
          <button class="manage-btn" @click="handleManageSubscription">Manage Subscription</button>
      
          <div v-if="unSubWindowVisible" class="unsubscribe-window">
              <p>At the moment, unsubscribing works via your email: </p>
              <ul>
                  <li>Go to your <strong>inbox.</strong></li>
                  <li>Find the <strong>email</strong> that confirmed your subscription, by our payment <strong>provider Polar.sh</strong></li>
                  <li>Open it and just click, <strong>Unsubscribe.</strong></li>
                  <li>If you can't find the email just <strong>contact us</strong>, and we will handle it for you.</li>
                  <li>Thank you!</li>
              </ul>
              <div class="button-container">
                  <button class="close-btn" @click="toggleUnsubscribeWindow">Close</button>
              </div>
          </div>
      </div>
      
      <div class="button-container" v-else>
          <PolarSub :user="user" />
      </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import { polarClient } from '@/lib/polar';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import PolarSub from '@/components/PolarSub.vue';
import User from '@/types/User';
import { useUserStore } from '@/stores/user';


const props = defineProps<{
  user: User;
}>();


const username = ref<string>('');
const unSubWindowVisible = ref<boolean>(false);

const authStore = useAuthStore();
const { session } = storeToRefs(authStore);
const apiUrl = process.env.VUE_APP_DJANGO_BACKEND;

const toggleUnsubscribeWindow = () => {
  unSubWindowVisible.value = !unSubWindowVisible.value;
};

const handleManageSubscription = async () => {
  try {
      const result = await polarClient.customerSessions.create({
        customerId: props.user.polar_customer_id
      });
      
      window.location.href = result.customerPortalUrl;
  } catch (error) {
      console.error('Error managing subscription:', error);
  }
};


onMounted(async () => {
  if (session.value) {
      username.value = session.value.user.email || "";
  }
});

</script>

<style scoped>

.card {
  background-color: white;
  width: 88%;
  /* border: 2px solid #ccc; */
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); */
  max-width: 400px;
  margin: 20px auto;
  padding-bottom: 20px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-bottom: 2px solid #ccc;
}

.card h1 {
      text-align: center;
      font-size: 2.2rem;
      line-height: 1.1;
      font-weight: 800;
      margin-bottom: -15px;
  }



.button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: center;
}

h2 {
    text-align: center;
}

.first-para {
  margin-top: 35px;
}

.unsubscribe-window {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* Keeps it centered */
  background-color: white;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 400px; /* Max width for the window */
  width: 100%; /* Ensures the window is responsive */
  box-sizing: border-box; /* Prevents padding from affecting the width */
}

hr.sub-hr {
    margin-top: 1rem;
    width: 100%;
    border: 1px solid gray;
}


.manage-btn {
  background: none;
  border: 3px solid rgb(236, 236, 15);
  font-size: 0.8rem;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  padding: 0.6rem 1.2rem;
  border-radius: 10px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background-color: rgb(236, 236, 15);
}

.manage-btn:hover {
  border-color: rgb(236, 236, 15);
  background-color: rgb(236, 236, 15);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

button.close-btn{
  padding: 10px 15px;
  display: flex;
  background-color: #e4d37b;
  color: rgb(0, 0, 0);
  border: none;
  border-radius: 3px;
  cursor: pointer;
}

button.unsubscribe-btn:hover {
  background-color: #cf2639;
}

button.close-btn:hover {
  background-color: #cf6f26;
}

.ul {
  margin-top: 30px;
}
</style>


